<template>
  <div class="page-main">
    <e-tabs :list="this.$constant.tabListRole()" isJump />
    <div :class="{ 'page-content': true, 'is-load-left': isLoadLeft }">
      <div class="page-left"></div>
      <div class="page-right">
        <!-- 表格操作条 -->
        <vxe-toolbar ref="refToolbar" size="mini" :loading="tableOptions.loading">
          <template #buttons>
            <el-button type="primary" size="mini" @click="batchDo('启用')"> 启用 </el-button>
            <el-button type="info" size="mini" @click="batchDo('禁用')"> 禁用 </el-button>
            <el-button type="danger" size="mini" @click="batchDo('删除')"> 删除 </el-button>
          </template>
          <template #tools>
            <el-button type="success" size="mini" @click="itemDo()"> 新增职位 </el-button>
          </template>
        </vxe-toolbar>

        <!-- 表格 -->
        <vxe-grid
          ref="refTable"
          v-bind="tableOptions"
          @keydown="tableKeydown"
          @current-change="tableCurrentChange"
        >
          <!-- slot_header -->
          <template #header_input="{ column }">
            <c-table-header
              :title="column.title"
              :field="column.field"
              :url="headerFilterUrl"
              @change="headerFilterChange"
            />
          </template>

          <!-- slot_default -->
          <template #default_ststus="{ row }">
            <el-switch type="primary" v-model="row.status" @change="itemSwitch(row)" />
          </template>
          <template #default_operate="{ row }">
            <el-link type="primary" @click="itemDo(row)">编辑</el-link>
            <el-link type="danger" @click="itemDelete(row)">删除</el-link>
          </template>

          <!-- slot_pager -->
          <template #pager>
            <div></div>
            <vxe-pager v-bind="tableOptions.pagerConfig" @page-change="pageChange" />
          </template>
        </vxe-grid>

        <!-- 弹窗-增改职位 -->
        <PopupDoJobStation
          v-if="isShowPopupDoJobStation"
          :show.sync="isShowPopupDoJobStation"
          :detailId="detailId"
          @success="searchListData"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PopupDoJobStation: () => import('./common/popup-do-job-station')
  },
  data() {
    return {
      isLoadLeft: false,
      filterData: {},
      headerFilterUrl: '/admin/gcvip/gangwei2/searchHeard',
      tableOptions: {
        loading: false,
        size: 'mini',
        border: true,
        height: this.$util.getViewHeight() - 187,
        pagerConfig: {
          ...this.$constant.page
        },
        columns: [
          {
            fixed: 'left',
            type: 'checkbox',
            width: 40
          },
          {
            fixed: 'left',
            title: '序号',
            type: 'seq',
            width: 40
          },
          { field: 'name', title: '职位名称', slots: { header: 'header_input' } },
          { field: 'code', title: '职位编码', slots: { header: 'header_input' } },
          { field: 'remark', title: '职位描述', slots: { header: 'header_input' } },
          { field: 'category_str', title: '职位分类', slots: { header: 'header_input' } },
          { field: 'department_str', title: '所属组织', slots: { header: 'header_input' } },
          { field: 'job_do_name', title: '所属职务', slots: { header: 'header_input' } },
          {
            field: 'job_level_name',
            title: '所属职级',
            slots: { header: 'header_input' }
          },
          {
            field: 'create_date',
            title: '创建时间',
            width: 160,
            slots: { header: 'header_input' }
          },
          {
            field: 'update_date',
            title: '更新时间',
            width: 160,
            slots: { header: 'header_input' }
          },
          {
            field: 'status',
            title: '状态',
            width: 80,
            slots: { default: 'default_ststus' }
          },
          { title: '操作', width: 160, slots: { default: 'default_operate' } }
        ],
        data: []
      },
      isShowPopupDoJobStation: false,
      detailId: '',
      detailData: {}
    }
  },
  mounted() {
    this.searchListData()
  },
  methods: {
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.tableOptions.pagerConfig.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.tableOptions.loading = true
      let filterData = {}
      Object.keys(this.filterData).forEach((key) => {
        if (this.filterData[key]) filterData[key] = this.filterData[key]
      })
      this.$api({
        method: 'post',
        url: '/admin/gcvip/gangwei2/list',
        data: {
          currentPage: this.tableOptions.pagerConfig.currentPage,
          pageSize: this.tableOptions.pagerConfig.pageSize,
          filterData,
          sortData: { id: 'desc' }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            this.tableOptions.data = res.data.page.list
            this.tableOptions.pagerConfig.pageSize = res.data.page.pageSize
            this.tableOptions.pagerConfig.total = res.data.page.totalRow
            this.tableOptions.pagerConfig.currentPage = res.data.page.pageNumber
          }
        })
        .catch(() => {})
        .then(() => {
          this.tableOptions.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.tableOptions.pagerConfig.currentPage = currentPage
      this.tableOptions.pagerConfig.pageSize = pageSize
      this.getListData()
    },
    // 获取-当前单选行
    getCheckboxRecords() {
      return this.$refs.refTable.getCheckboxRecords()
    },
    // 表格-高亮行更改
    tableCurrentChange(params) {
      this.$refs.refTable.setCheckboxRow(params.row, true) // 选中checkbox
    },
    // 表格-键盘空格
    tableKeydown(params) {
      if (params.$event.code === 'Space') {
        let row = this.$refs.refTable.getCurrentRecord()
        let isCurrentRowCheckbox = this.$refs.refTable.isCheckedByCheckboxRow(row)
        this.$refs.refTable.setCheckboxRow(row, !isCurrentRowCheckbox) // 选中checkbox
      }
    },
    // 项-选择提示
    itemChoosePrompt() {
      this.$tool.tableChoosePrompt()
    },
    // 项-增改
    itemDo(row) {
      if (row === undefined) {
        this.detailId = ''
      } else {
        this.detailId = row.id
      }
      this.isShowPopupDoJobStation = true
    },
    // 项-删除
    itemDelete(row) {
      this.$confirm('您确认要删除该数据?', '提示')
        .then(() => {
          let params = {
            ids: [row.id],
            type: '删除'
          }
          this.batchDoConfirm(params)
        })
        .catch(() => {})
    },
    // 项-切换状态
    itemSwitch(row) {
      let params = {
        ids: [row.id],
        type: row.status ? '启用' : '禁用'
      }
      this.batchDoConfirm(params)
    },
    // 批量-切换状态
    batchDo(type) {
      let rows = this.getCheckboxRecords()
      if (rows.length) {
        this.$confirm(`您确认要 "批量${type}" 选中的 "${rows.length}" 项数据?`, '提示')
          .then(() => {
            let params = {
              ids: rows.map((item) => item.id),
              type
            }
            this.batchDoConfirm(params)
          })
          .catch(() => {})
      } else {
        this.itemChoosePrompt()
      }
    },
    // 批量操作-确认
    batchDoConfirm(data) {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/gangwei2/batch',
        data
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('操作成功')
          this.getListData()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
  display: flex;
  flex-direction: column;
  .page-content {
    height: 100%;
    position: relative;
    &.is-load-left {
      .page-left {
        position: absolute;
        top: 0;
        bottom: 0;
        width: 318px;
        border: 1px solid #e4e7ed;
        border-radius: 4px;
      }
      .page-right {
        margin-left: 330px;
      }
    }
  }
}
</style>
